import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
// import { Input as ReactInput, Label } from "@vzrf/react-forms";
import { Input } from "@vds/inputs"; 
import { convertStringToElements } from "@vds/html-parsers";

import { media } from "utils/style";
import { setA11yContent } from "../../NavigationHelper/actions";
import { checkNestedObject } from "utils/checkNestedObject";
import styled from "styled-components";

import Button from "common-components/Buttons";
import Loader from "common-components/RectangleLoader";
import CommonContainer from "common-components/Container";
import RectangleLoader from "common-components/RectangleLoader/RectangleLoader";
import PropTypes from "prop-types";
import FetchPageContent from "../../../../hoc/FetchPageContent";
import { sendSecurePinToDevice } from "../../FormerCustomer/actions/commonFormerCustomerAPI";
import { MaximumPasswordsReached } from "../../ResendPassword";
import FallbackUI from "../../FallbackUI/FallbackUI";
import { resendPasswordBegin } from "../actions/resendPassword";
import Warning from "../../../../../assets/svgs/Warning.svg";
import SuccessInputImg from "../../../../../assets/svgs/SuccessInputImg.svg";

const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;

class DownloadEmailAuthentication extends Component {
    state = {
        email: "",
        error: "",
        emailValidation: false,
        showMaxPasswordModal: false,
        errorCheck: true
    };

    componentDidMount() {
        if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
            this.props.setA11yContent("email info", this.props.pageContent.sc_pagetitle);
        }
    }

    handleSubmit = e => {
        e.preventDefault();
        const { authToken, loginEmailID } = this.props.location.state;
        const { email } = this.state;
        if (email.toLowerCase() === loginEmailID.toLowerCase()) {
            this.props.history.push({
                pathname: "/privacy/your-data/guest-download/" + authToken,
                state: {
                    page: "verify",
                    authToken: authToken
                }
            });
        } else if (email.toLowerCase() !== loginEmailID.toLowerCase()) {
            this.setState({ error: this.props.pageContent.section_description })
        }
    }

    updateEmail = ({ target: { value, name } }) => {
        this.setState({ [name]: value.replace(/[^\w\s/@#$%^&\-\*():;"?_|.,+=!|\\]/gi, "") }, () => {
            if (this.state.error) {
                this.setState({ error: false })
            }
            if (this.state.email && !this.state.email.match(isValidEmail)) {
                this.setState({ emailValidation: false })
            }
        });
    };

    render() {
        const { pageContent, loading, location } = this.props;

        if (!pageContent) {
            return <FallbackUI />;
        }

        if (loading) {
            return <RectangleLoader id={"downloadLoader"} />;
        }

        const {
            genericList: [{ list: inputList }],
            buttons
        } = pageContent;

        return (
            <div
                id={"headerContainer"}
                onMouseMove={(ev) => {
                    if (this.state.email && this.state.email.match(isValidEmail) && (this.state.email.toLowerCase() === location.state.loginEmailID.toLowerCase())) {
                        this.setState({
                            emailValidation: true,
                            error: ""
                        })
                    } else if ((this.state.email && !this.state.email.match(isValidEmail))) {
                        this.setState({
                            error: "Invalid Email Format"
                        })

                    } else if (this.state.email && this.state.email.toLowerCase() !== location.state.loginEmailID.toLowerCase()) {
                        this.setState({
                            error: this.props.pageContent.section_description
                        })
                    }
                }}>
                <Fragment>
                    <Container>
                        {this.props.loading ? (
                            <Loader />
                        ) : (
                            <Fragment>
                                <H1>{pageContent.section_title}</H1>
                                <form onSubmit={this.handleSubmit}>
                                    <div>
                                        {inputList &&
                                            inputList.length &&
                                            inputList.map(({ jsonKey, jsonValue, uniqueId }) => (
                                                <Fragment key={uniqueId}>
                                                    <InputContainer>
                                                        {/* <Label
                                                            htmlFor={uniqueId}
                                                            style={{ fontFamily: "Verizon-NHG-eTX", color: "#000000", fontSize: "12px", lineHeight: "16px" }}
                                                        >
                                                            {jsonKey}
                                                        </Label> */}

                                                        <Input
                                                            type="text"
                                                            label={jsonKey}
                                                            width={'328px'}
                                                            className={this.state.error ? "icon" : this.state.email && this.state.emailValidation ? "successicon" : ""}
                                                            id={uniqueId}
                                                            data-testid="email"
                                                            name={uniqueId}
                                                            value={this.state[uniqueId]}
                                                            maxLength="50"
                                                            aria-describedby={`${uniqueId}_error`}
                                                            autoComplete="off"
                                                            onChange={this.updateEmail}
                                                            onBlur={() => {
                                                                if (this.state.email && this.state.email.match(isValidEmail) && (this.state.email.toLowerCase() === location.state.loginEmailID.toLowerCase())) {
                                                                    this.setState({
                                                                        emailValidation: true,
                                                                        error: ""
                                                                    })
                                                                } else if (this.state.email && !this.state.email.match(isValidEmail)) {
                                                                    this.setState({
                                                                        error: "Invalid Email Format"
                                                                    })
                                                                }
                                                                else if (this.state.email && this.state.email.toLowerCase() !== location.state.loginEmailID.toLowerCase()) {
                                                                    this.setState({
                                                                        error: this.props.pageContent.section_description
                                                                    })
                                                                }
                                                            }}
                                                        />

                                                        {(this.props.error || this.state.error) && (
                                                            <ErrorMsg role="alert" id={`${uniqueId}_error`}>
                                                                {this.props.error || this.state.error}
                                                            </ErrorMsg>
                                                        )}
                                                    </InputContainer>
                                                </Fragment>
                                            ))}
                                    </div>
                                    <Button
                                        type="submit"
                                        disabled={!this.state.email}
                                        style={{ marginTop: "44px" }}
                                        background={buttons[0].type}
                                    >
                                        {buttons[0].text}
                                    </Button>
                                </form>
                            </Fragment>
                        )}
                        {this.state.showMaxPasswordModal ? (
                            <MaximumPasswordsReached
                                modalContent={this.props.maxPasswordsModal}
                                closeModal={() => this.setState({ showMaxPasswordModal: false })}
                            // check if below needed
                            // historyLinkClick={() => this.props.history.push("request-history")}
                            // historyLinkRole="link"
                            />
                        ) : null}
                    </Container>
                </Fragment></div>
        );
    }
}

DownloadEmailAuthentication.propTypes = {
    setA11yContent: PropTypes.func.isRequired,
    pageContent: PropTypes.object
};

const mapStateToProps = ({
    pageContent,
    loadingAndErrorState: { loading, error },
    formerCustomer: { accountInfo: formerCustomerAccountInfo, formerId }
}) => ({
    pageContent: pageContent.email_form,
    maxPasswordsModal: pageContent.maximum_passwords_reached,
    loading,
    error,
    formerCustomerAccountInfo,
    formerId
});

export default compose(
    connect(
        mapStateToProps,
        { setA11yContent, sendSecurePinToDevice, resendPasswordBegin }
    ),
    FetchPageContent
)(DownloadEmailAuthentication);

const ErrorMsg = styled.span`
  display: block;
  font-size: 10px;
  line-height: 10px;
  font-family: "Verizon-NHG-eTX", Helvetica, Arial, sans-serif;
  max-width: 464px;
  margin-top: 5px;
  position:absolute;
  color:#C44904;

  ${media.mobile`
    max-width: 100%;  
  `}
`;

const H1 = styled.h1`
  font-size: 48px;
  line-height: 48px;
  width: 490px;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
  font-style: normal;
  padding-bottom: 12px;

  ${media.mobile`
    max-width: 100%;
    font-style: normal;
    font-weight: 400;
    font-size: 32px;
    line-height: 36px;
    font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
`}
`;

// const Input = styled(ReactInput)`
//   width: 464px;
//   border: 1px solid #6F7171;
//   border-radius: 4px;
//   max-width: 424px;
//   ${media.mobile`
//     width: 100%;
//   `}
// `;

const InputContainer = styled.div`
  flex: 50%;
  margin-top:14px;
  div {
    display: block;
  }
//   .successicon {
//     padding-left: 25px;
//     background: url(${SuccessInputImg})no-repeat left;
//     background-size: 20px;
//     background-position: 99%;
//     border: 1px solid  #008331;
//     border-radius: 4px;
//     background-color:#DCF5E6;
//   }
//   .icon {
//     padding-left: 25px;
//     background: url(${Warning})no-repeat left;
//     background-size: 20px;
//     background-position: 99%;
//     border: 1px solid  #C44904 !important;
//     background-color:#FBE4D7;
//     border-radius: 4px;
//   }
  ${media.mobile`
    flex: 100%;
  `}
`;

const Container = styled(CommonContainer)`
  margin: 0px 0px 0px 20px;
  padding: 47px 80px ;

  ${media.mobile`
    padding: 48px 16px ;
  `}
`;